"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _useStylesUtils = require("../../hooks/useStylesUtils");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = (props, isOpen) => {
  const {
    fontFamily
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem,
    maskProps
  } = (0, _useStylesUtils.useStylesUtils)();
  const {
    arrowSpaceSize = 'medium',
    anchorWidth = 'fit-content',
    isWithArrow = true
  } = props;
  const ccSelectStyle = (0, _react.useMemo)(() => {
    const arrowProps = () => {
      const marginInlineStart = arrowSpaceSize === 'small' ? pxToRem(4) : arrowSpaceSize === 'medium' ? pxToRem(8) : pxToRem(12);
      return {
        marginInlineStart
      };
    };
    const ccSelectMask = (0, _css.css)({
      ...maskProps(isOpen)
    });
    const ccSelect = (0, _css.css)({
      fontFamily: fontFamily,
      display: anchorWidth === 'auto' ? 'block' : 'inline-block',
      position: 'relative',
      maxWidth: '100%'
    });
    const ccSelectBtn = (0, _css.css)({
      display: 'flex',
      justifyContent: 'space-between',
      width: isWithArrow ? '100%' : undefined,
      alignItems: 'center'
    });
    const ccSelectBtnLabel = (0, _css.css)({
      display: 'inline-block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    });
    const ccSelectBtnArrow = (0, _css.css)({
      display: 'flex',
      ...arrowProps()
    });
    return {
      ccSelectMask,
      ccSelect,
      ccSelectBtn,
      ccSelectBtnLabel,
      ccSelectBtnArrow
    };
  }, [anchorWidth, arrowSpaceSize, fontFamily, isWithArrow, isOpen, maskProps, pxToRem]);
  return {
    'cc-Select-mask': ccSelectStyle.ccSelectMask,
    'cc-Select': ccSelectStyle.ccSelect,
    'cc-Select__btn': ccSelectStyle.ccSelectBtn,
    'cc-Select__btn__label': ccSelectStyle.ccSelectBtnLabel,
    'cc-Select__btn__arrow': ccSelectStyle.ccSelectBtnArrow
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;